// extracted by mini-css-extract-plugin
export default {"background_circle":"Home_background_circle__BKZcE","background_circle_pc":"Home_background_circle_pc__RUK+9"};